<template>
  <div>
    <Panel :module="panel.module" :title="panel.title" :showFilter="panel.showFilter" :showSearch="panel.showSearch"
      :showButtons="panel.showButtons">
      <div slot="content-main">
        <div>
          <br>
          <b-tabs v-model="tabIndex" lazy>
            <b-tab v-for="(t, i) in tabs" :key="i" :title="t.title">
              <component :is="t.comp" />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import CategoryCustomer from "./CategoryCustomer.vue";
import OriginCustomer from "./OriginCustomer.vue";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "ConfiguracaoCrmView",
  components: { Panel, CategoryCustomer, OriginCustomer },
  data() {
    return {
      tabIndex: 0,
      tabs: [
        { title: "Categoria", comp: CategoryCustomer },
        { title: "Origem", comp: OriginCustomer },
      ],
      panel: {
        module: "Cliente",
        title: "Configuração",
        showFilter: false,
        showSearch: false,
        showButtons: false,
      },
    };
  },
  created() {
    const saved = this.get_FilterStorage(this.$route.name);
    this.tabIndex =
      saved && typeof saved.tabIndex === "number" ? saved.tabIndex : this.tabIndex;
    this._addFilterStorage({ routeName: this.$route.name, tabIndex: this.tabIndex });
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  watch: {
    tabIndex(val) {
      this._addFilterStorage({ routeName: this.$route.name, tabIndex: val });
    },
  },
  computed: {
    ...mapGetters("generic", ["get_FilterStorage"]),
  },
  methods: {
    ...mapMutations("generic", ["_addFilterStorage", "removeLoading"]),
  },
};
</script>
